// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header-module--Header--1JJBT","containerLogo":"Header-module--containerLogo--1NhDO"};